import { questionTypes } from 'sharedParts';
import DropdownQuestion from 'components/questions/dropdown/DropdownQuestion';
import LongTextQuestion from 'components/questions/LongTextQuestion';
import ShortTextQuestion from 'components/questions/ShortTextQuestion';
import MultiChoiceQuestion from 'components/questions/MultiChoiceQuestion';
import ScaleQuestion from 'components/questions/scaleQuestion/ScaleQuestion';
import StaticText from 'components/questions/StaticText';
import SingleQuestion from 'components/questions/SingleQuestion';
import SocialQuestion from 'components/questions/SocialQuestion/SocialQuestion';
import ButtonContent from 'components/questions/ButtonContent';
import MatrixRadioQuestion from 'components/questions/matrix/MatrixRadioQuestion';
import MatrixMultiQuestion from 'components/questions/matrix/MatrixMultiQuestion';
import MatrixScaleQuestion from 'components/questions/matrix/MatrixScaleQuestion';
import PageBreakTaker from 'components/questions/PageBreakTaker';
import ImageMultiChoiceQuestion from 'components/questions/imageQuestion/ImageMultiChoiceQuestion';
import ImageSingleQuestion from 'components/questions/imageQuestion/ImageSingleQuestion';
import NumericQuestion from 'components/questions/numericQuestion/NumericQuestion';
import RespondentCompanyNameQuestion from '../components/questions/respondentInfo/RespondentCompanyNameQuestion';
import RespondentDropdownQuestion from '../components/questions/respondentInfo/RespondentDropdownQuestion';
import RespondentFirstNameQuestion from '../components/questions/respondentInfo/RespondentFirstNameQuestion';
import RespondentLastNameQuestion from '../components/questions/respondentInfo/RespondentLastNameQuestion';
import RespondentLongTextQuestion from '../components/questions/respondentInfo/RespondentLongTextQuestion';
import RespondentMailQuestion from '../components/questions/respondentInfo/RespondentMailQuestion';
import RespondentMultiChoiceQuestion from '../components/questions/respondentInfo/RespondentMultiChoiceQuestion';
import RespondentPhoneQuestion from '../components/questions/respondentInfo/RespondentPhoneQuestion';
import RespondentShortTextQuestion from '../components/questions/respondentInfo/RespondentShortTextQuestion';
import RespondentSingleQuestion from '../components/questions/respondentInfo/RespondentSingleQuestion';
import RespondentBlankQuestion from '../components/questions/respondentInfo/RespondentBlankQuestion';

export default {
  [questionTypes.nextButton]: PageBreakTaker,
  [questionTypes.redirectButton]: ButtonContent,
  [questionTypes.submitButton]: PageBreakTaker,
  [questionTypes.respondentBlankField]: RespondentBlankQuestion,
  [questionTypes.respondentCompanyName]: RespondentCompanyNameQuestion,
  [questionTypes.respondentMail]: RespondentMailQuestion,
  [questionTypes.respondentFirstName]: RespondentFirstNameQuestion,
  [questionTypes.respondentLastName]: RespondentLastNameQuestion,
  [questionTypes.respondentPhone]: RespondentPhoneQuestion,
  [questionTypes.respondentInfoMulti]: RespondentMultiChoiceQuestion,
  [questionTypes.respondentInfoRadio]: RespondentSingleQuestion,
  [questionTypes.respondentInfoLongText]: RespondentLongTextQuestion,
  [questionTypes.respondentInfoShortText]: RespondentShortTextQuestion,
  [questionTypes.respondentInfoDropdown]: RespondentDropdownQuestion,
  [questionTypes.shortText]: ShortTextQuestion,
  [questionTypes.longText]: LongTextQuestion,
  [questionTypes.questionDropdown]: DropdownQuestion,
  [questionTypes.questionImageMulti]: ImageMultiChoiceQuestion,
  [questionTypes.questionImageSingle]: ImageSingleQuestion,
  [questionTypes.questionMulti]: MultiChoiceQuestion,
  [questionTypes.questionScale]: ScaleQuestion,
  [questionTypes.questionNumeric]: NumericQuestion,
  [questionTypes.questionMatrixRadio]: MatrixRadioQuestion,
  [questionTypes.questionMatrixMulti]: MatrixMultiQuestion,
  [questionTypes.questionMatrixScale]: MatrixScaleQuestion,
  [questionTypes.questionSingle]: SingleQuestion,
  [questionTypes.socialFollow]: SocialQuestion,
  [questionTypes.staticText]: StaticText,
};
